import { render, staticRenderFns } from "./searchGoods.vue?vue&type=template&id=9919f6a8&"
import script from "./searchGoods.vue?vue&type=script&lang=js&"
export * from "./searchGoods.vue?vue&type=script&lang=js&"
import style0 from "./searchGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports